import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import * as moment from 'moment';
import { InfoIdentidad } from '../../../../models/info-Identidad';
import { InfoIdentidadService } from '../../../../services/info-identidad.service';
import { MomentSetService } from '../../../../core/services/moment-set.service';

@Component({
  selector: 'app-info-identidad-list',
  templateUrl: './info-identidad-list.component.html',
  styleUrls: ['./info-identidad-list.component.css']
})
export class InfoIdentidadListComponent implements OnInit
{

  @Input() personalId: number;
  @Input() infoIdentidades: InfoIdentidad[];
  @Input() permisoEdicion: boolean = true;
  @Input() fechaslist;
  @Output() VisualizarDetalle = new EventEmitter<InfoIdentidad>();

  infoIdentidadesOri: InfoIdentidad[];
  infoIdentidadesGrupo: InfoIdentidad[];
  filtroDesde: string;
  filtroHasta: string;
  agrupar: boolean = false;

  constructor(private infoIdentidadService: InfoIdentidadService,
              private momentService: MomentSetService) { }

  ngOnInit(): void
  {
    this.infoIdentidadesOri = this.infoIdentidades;
    this.inicializaFiltros();
    
    this.filtrarInfoIdentidades();
  }

  inicializaFiltros()
  {
    let fechaHoy = new Date();
    let fechaIni = new Date();
    fechaIni.setDate(fechaIni.getDate() - 30);

    let mesString = ('0' + (fechaIni.getMonth() + 1).toString()).slice(-2); //agrega cero por si es menor de 10
    let diaString = ('0' + (fechaIni.getDate()).toString()).slice(-2); //agrega cero por si es menor de 10
    this.filtroDesde = (fechaIni.getFullYear()).toString() + "-" + mesString + "-" + diaString ;

    mesString = ('0' + (fechaHoy.getMonth() + 1).toString()).slice(-2); //agrega cero por si es menor de 10
    diaString = ('0' + (fechaHoy.getDate()).toString()).slice(-2); //agrega cero por si es menor de 10
    this.filtroHasta = (fechaHoy.getFullYear()).toString() + "-" + mesString + "-" + diaString ;
  }

  filtrarInfoIdentidades()
  {
    let desde = moment(this.filtroDesde, "YYYY/MM/DD").toDate();
    let hasta = moment(this.filtroHasta, "YYYY/MM/DD").toDate();
    
    this.infoIdentidades = this.infoIdentidadesOri.filter(i => Date.parse(i.desde) <= hasta.getTime() && Date.parse(i.hasta) >= desde.getTime());
  }

  onChangeAgrupamiento()
  {
    //Cambia lista
    if (this.agrupar == true)
    {
      if (this.infoIdentidadesGrupo == undefined)
      {
        this.infoIdentidadService.getByPersonal(this.personalId, true).subscribe(
          data =>
          {
            data.forEach((currentValue,index,arr) => {
              currentValue.desde = this.momentService.convertDateServer(currentValue.desde);
              currentValue.hasta = this.momentService.convertDateServer(currentValue.hasta);
              currentValue.fechaEmision = this.momentService.convertDateServer(currentValue.fechaEmision);
              currentValue.fechaValidez = this.momentService.convertDateServer(currentValue.fechaValidez);
            });
            
            this.infoIdentidadesGrupo = data;
            this.infoIdentidades = this.infoIdentidadesGrupo;
          });

      } else
      {
        this.infoIdentidades = this.infoIdentidadesGrupo;
      }
      
    } else
    {
      this.filtrarInfoIdentidades();
    }
  }

  onChangeFiltros()
  {
    this.filtrarInfoIdentidades();
  }

  visualizarDetalle(info)
  {
    this.VisualizarDetalle.emit(info);
  }

  add()
  {
    let fdesde = new Date().toString();
    let fecha = this.fechaslist.find(d => d.claseFechaNavigation.codigo == "01");
    if (fecha != undefined){
      fdesde = fecha.desde
    } 
    let infoIdentidad: InfoIdentidad = { id: 0, personal: this.personalId, desde: fdesde, hasta: new Date("2999-12-31T23:59:59").toString(), claseDocumento: 0, docNro: '', fechaEmision: new Date().toString(), fechaValidez: new Date().toString(), lugarEmision: '', nroEmision: '', paisEmisor: 0, autoridad: '' };
    this.VisualizarDetalle.emit(infoIdentidad);
  }
}
